<template>
  <div class="button-next">
    <button @click="handleClick" class="next-step" :class="[{'disabled': isDisabled}, extraClass]">
      {{ text }}
    </button>
    <p v-if="showMsg">{{ message }}</p>
  </div>
</template>
<script>
export default {
  props: ['onClick', 'isDisabled', 'text', 'extraClass', 'customMessage'],
  computed: {
    showMsg: function() {
      return this.clicked && this.isDisabled
    }
  },
  data() {
    const custMsg = this.customMessage;
    return {
      clicked: false,
      message: custMsg !== undefined && custMsg !== null ? custMsg : 'Please make a selection before continuing'
    }
  },
  methods: {
    handleClick() {
      this.clicked = true
      if (this.isDisabled) return
      this.onClick()
    }
  }
}
</script>
